import {isEqual, set} from "lodash";
import {SnackbarKey} from "notistack";
import {useEffect} from "react";

import {hasBrowserWindowAccess} from "@buildwithflux/shared";
import {useFluxSnackbar} from "components/common/hooks/useFluxSnackbar";
import {useNotifications, useRemoveNotification} from "modules/app/state/app";

let displayed: SnackbarKey[] = [];

const storeDisplayed = (id: SnackbarKey) => {
    displayed = [...displayed, id];
};

const removeDisplayed = (id: SnackbarKey) => {
    displayed = [...displayed.filter((key) => id !== key)];
};

const useNotifiers = () => {
    const notifications = useNotifications();
    const removeNotification = useRemoveNotification();
    const {enqueueSnackbar, closeSnackbar} = useFluxSnackbar();

    useEffect(() => {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        notifications.forEach((notification) => {
            const {message, key, options, dismiss} = notification;
            if (dismiss) {
                closeSnackbar(key);
                return;
            }

            // do nothing if snackbar is already displayed
            if (displayed.includes(key)) {
                return;
            }

            // display snackbar using notistack
            enqueueSnackbar(message, "zustand", {
                key,
                ...options,
                onClose: (event, reason, myKey) => {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey);
                    }
                },
                onExited: (event, myKey) => {
                    if (options.onExited) {
                        options.onExited(event, myKey);
                    }
                    // remove this snackbar from zustand store
                    removeNotification(myKey);
                    removeDisplayed(myKey);
                },
            });

            storeDisplayed(key);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar, removeNotification]);

    useEffect(() => {
        if (hasBrowserWindowAccess()) {
            set(window, ["__FLUX__", "ui"], {
                showSnackbar: (message?: string) => {
                    enqueueSnackbar(message ?? "Test snackbar", "dev-tools", {persist: false});
                },
            });
        }
    }, [enqueueSnackbar]);
};

export default useNotifiers;
